<template>
  <div class="upper-subpanel--inside">
    <div class="col-6">
      <DrugInfo/>
    </div>
    <div class="col-6">
      <ConfirmFlow v-if="currentProgress === 'confirm'"
       :confirmProgress="confirmProgress"
       v-on:confirmationFinish="getConfirmData"></ConfirmFlow>
      <Loader v-if="currentProgress === 'finish'" />   
    </div>
  </div>
</template>

<script>
import DrugInfo from '../flowComp/DrugInfo';
import ConfirmFlow from './ConfirmFlow';
import Loader from '../common/Loader';
import MultiFlowBase from '../ComponentBase/MultiFlowBase';

export default {
  name: 'multiFlow',
  extends: MultiFlowBase,
  props: [],
  data() {
    return {
    };
  },
  components: {
    DrugInfo,
    ConfirmFlow,
    Loader,
  },
  methods: {
    getConfirmData() {
      this.nextProgress();
      if (this.nextEvent === null) {
        this.$emit('setAllConfirmData');
      } else {
        this.$store.dispatch('toNextEvent');
        console.log('next event');
        setTimeout(() => {
          this.resetProgress();
        }, 200);
      }
    },
  },
  created() {
    this.$store.dispatch('fromFirstEvent');
  },
  mounted() {
  },
  computed: {
    selectedEvent() {
      return this.$store.state.event.selectedEvent;
    },
    eventKeys() {
      return Object.keys(this.$store.state.event.selectedEvent);
    },
  },
};
</script>



// WEBPACK FOOTER //
// MultiFlow.vue?74885d38